// Tokens open on Cardanoscan; chain references open on AdaStat instead. [[knowledge-explorer-links]]
const CARDANOSCAN = "https://cardanoscan.io";

// The bot names ADA by its unit, `lovelace`; every other asset by policy id + hex asset name.
export const LOVELACE = "lovelace";
const POLICY_ID_HEX_LEN = 56;

export interface AssetIdentity {
    id: string;
    name: string;
}

export const ADA: AssetIdentity = { id: LOVELACE, name: "ADA" };

/** Some sources separate the policy id from the asset name; Cardanoscan takes them joined. */
export const unitId = (id: string) => id.replace(/[.:]/g, "");

export const policyId = (id: string) => unitId(id).slice(0, POLICY_ID_HEX_LEN);

/** ADA has no token page, so it links to the explorer itself. */
export const cardanoscanAsset = (id: string) =>
    id === LOVELACE ? `${CARDANOSCAN}/` : `${CARDANOSCAN}/token/${unitId(id)}`;

/** A tracked pair is keyed `<asset A id>/<asset B id>`, and the token is asset B. */
export const tokenIdOfPair = (pair: string) => pair.slice(pair.indexOf("/") + 1);
